import {
  RadarChart as RechartsRadar,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'
import type { DimensionScore } from '@/types'
import { dimensionLabel } from '@/lib/utils'

interface Props {
  scores: DimensionScore[]
  compact?: boolean
}

const COLORS = {
  fill: 'rgba(0, 61, 165, 0.15)',
  stroke: '#003DA5',
}

export function AssessmentRadarChart({ scores, compact = false }: Props) {
  const data = scores.map((ds) => ({
    dimension: dimensionLabel(ds.dimension),
    score: Number(ds.score),
    fullMark: 5,
  }))

  if (data.length === 0) return null

  return (
    <ResponsiveContainer width="100%" height={compact ? 220 : 320}>
      <RechartsRadar
        data={data}
        margin={{ top: 10, right: 20, bottom: 10, left: 20 }}
      >
        <PolarGrid stroke="hsl(var(--border))" />
        <PolarAngleAxis
          dataKey="dimension"
          tick={{
            fontSize: compact ? 10 : 11,
            fill: 'hsl(var(--muted-foreground))',
          }}
        />
        <PolarRadiusAxis
          angle={90}
          domain={[0, 5]}
          tickCount={6}
          tick={{ fontSize: 9, fill: 'hsl(var(--muted-foreground))' }}
        />
        <Tooltip
          formatter={(value: number) => [`${value}/5`, 'Score']}
          contentStyle={{
            background: 'hsl(var(--popover))',
            border: '1px solid hsl(var(--border))',
            borderRadius: '8px',
            fontSize: '12px',
          }}
        />
        <Radar
          name="Score"
          dataKey="score"
          stroke={COLORS.stroke}
          fill={COLORS.fill}
          fillOpacity={1}
          dot={{ r: 4, fill: COLORS.stroke }}
          activeDot={{ r: 6 }}
        />
      </RechartsRadar>
    </ResponsiveContainer>
  )
}
